import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import home from '../views/daily'

const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

let constantRoutes = [
  {
    path: '/',
    name: 'home',
    title: '首页',
    component: home
  },
  {
    path:'*',
    name: '404',
    component: () => import('../views/404')
  },
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router


// WEBPACK FOOTER //
// ./src/router/index.js